module.exports = "<select id=\"year-selector\" (change)=\"yearChanged($event)\">\n  <option *ngFor=\"let year of years\" value=\"{{year}}\">{{year}}</option>\n</select>"


//////////////////
// WEBPACK FOOTER
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/year-selector/year-selector.component.html
// module id = ../../../../../src/app/components/year-selector/year-selector.component.html
// module chunks = main